"use client";

import { useTranslations } from "next-intl";

/** The inline state shown where a lazily loaded feature could not be fetched. */
export function ChunkRetry({ onRetry }: { onRetry: () => void }) {
  const t = useTranslations("chunkError");
  return (
    <div role="status" className="text-wx-fg-muted flex items-center gap-2 p-3 text-xs">
      <span>{t("failed")}</span>
      <button
        type="button"
        onClick={onRetry}
        className="text-wx-primary rounded-wx-sm font-medium underline underline-offset-2"
      >
        {t("retry")}
      </button>
    </div>
  );
}
